/**
 * BodyMapConcepts — design gallery page now backed by the production
 * <ClinicalWorkspace/> component. Same surface as the in-session view,
 * driven by mock data, so the user can iterate without touching real
 * sessions.
 */
import React from "react";
import { ArrowLeft, Info } from "lucide-react";
import { Link } from "react-router-dom";
import ClinicalWorkspace from "../components/clinical/ClinicalWorkspace";
import {
  DEMO_CLIENT, DEMO_SESSION_META, DEMO_STATS,
  DEMO_TREATMENT_MAP, DEMO_TREATMENT_STEPS, DEMO_RATIONALE, DEMO_EXPECTED,
  DEMO_FINDINGS, DEMO_PREVIOUS_FINDINGS, DEMO_NEW_SINCE_LAST_VISIT,
  DEMO_TREATMENT_LOGIC, DEMO_LEARNING_LIBRARY, DEMO_CLIENT_PLAIN_STEPS,
} from "../components/clinical/workspaceDemoData";

export default function BodyMapConcepts() {
  return (
    <div className="min-h-screen bg-slate-900 pb-20 text-slate-100">
      <header className="bg-slate-950 border-b border-slate-800 sticky top-0 z-30">
        <div className="max-w-[1600px] mx-auto px-4 md:px-6 py-3 flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-4">
            <Link to="/" className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-slate-100" data-testid="back-to-app">
              <ArrowLeft className="w-4 h-4" /> Back to app
            </Link>
            <div className="h-5 w-px bg-slate-800" />
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Design preview · demo data</div>
              <h1 className="text-base text-slate-100">Posturra · unified clinical workspace</h1>
            </div>
          </div>
          <div className="text-[11px] text-slate-500 inline-flex items-center gap-1.5">
            <Info className="w-3.5 h-3.5" /> Toggles + click any highlight for finding details
          </div>
        </div>
      </header>

      <main className="max-w-[1600px] mx-auto px-4 md:px-6 py-5">
        <ClinicalWorkspace
          client={DEMO_CLIENT}
          sessionMeta={DEMO_SESSION_META}
          stats={DEMO_STATS}
          treatmentMap={DEMO_TREATMENT_MAP}
          treatmentSteps={DEMO_TREATMENT_STEPS}
          treatmentRationale={DEMO_RATIONALE}
          treatmentConfidence={0.84}
          treatmentBasis="Based on 3 prior sessions + posture analysis"
          expectedResult={DEMO_EXPECTED}
          previousFindings={DEMO_PREVIOUS_FINDINGS}
          newSinceLastVisit={DEMO_NEW_SINCE_LAST_VISIT}
          treatmentLogic={DEMO_TREATMENT_LOGIC}
          findingsLibrary={DEMO_FINDINGS}
          learningLibrary={DEMO_LEARNING_LIBRARY}
          clientPlainSteps={DEMO_CLIENT_PLAIN_STEPS}
          progressPct={67}
        />
      </main>
    </div>
  );
}
